import { NextImage } from '@zurich-framework/nextapp/components';
import { Icon, Stack } from '@zurich/ui/atoms';
import { styled } from '@zurich/ui/legacy/utils';

type PhotoTipImgProps = {
  src: string;
  alt: string;
  correct: boolean;
};

export function PhotoTipImg({ src, alt, correct }: PhotoTipImgProps) {
  return (
    <Stack>
      <NextImage src={src} alt={alt} width={160} height={116} />
      <Stack alignItems="center" justifyContent="center" alignContent="center">
        <StackStyled correct={correct}>
          <Icon variant={correct ? 'check' : 'close'} size="small" />
        </StackStyled>
      </Stack>
    </Stack>
  );
}

const StackStyled = styled(Stack)<{ correct: boolean }>(
  ({ theme, correct }) => ({
    marginTop: `-${theme.spacing(1.5)}`,
    height: theme.spacing(3),
    width: theme.spacing(3),
    backgroundColor: correct
      ? theme.palette.success.main
      : theme.palette.error.main,
    color: 'white',
    borderRadius: '50%',
    textAlign: 'center',
  })
);
